/* Core & libraries */
import React, {useEffect, useState} from "react";
import { useTheme } from "react-jss";
import { useParams } from "react-router";

/* Helpers, constants, custom methods, internal libraries */
import { useGuestProfileService } from "../../services/guestProfileService";
import { useUserContext } from "../../contexts/userContext";
import { AIRLINES } from "../../constants/appConstants";

/* Components */
import GuestProfileHeader from "../../components/guestProfileHeader";
import GuestProfileFormAC from "../../components/guestProfileForm/AC";
import GuestProfileFormAS from "../../components/guestProfileForm/AS";

/* Styles */
import styles from "./styles";

const GuestProfile = () => {
  const theme = useTheme();
  const classes = styles({ theme });
  const { getGuestProfile } = useGuestProfileService();
  const userDetails = useUserContext();
  const isAC = userDetails?.userInfo?.providerInfo?.providerCode === AIRLINES.AC;
  const [guestProfileDetails, setGuestProfileDetails] = useState(null);
  const { guestId } = useParams();
  
  useEffect(() => {
    (async () => {
      if (guestId) {
        const response = await getGuestProfile(guestId)
        if (response) {
          setGuestProfileDetails(response);
        }
      }
    })()
  }, [guestId]);
  
  return (
    <div>
      <div className={classes.profilePageHeader}>
        <GuestProfileHeader
          guestId={guestId}
          guestDetails={guestProfileDetails}
        />
        {isAC
          ? <GuestProfileFormAC guestId={guestId} guestDetails={guestProfileDetails} />
          : <GuestProfileFormAS guestId={guestId} guestDetails={guestProfileDetails} />
        }
      </div>
    </div>
  )
}

export default GuestProfile;
